document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('.menu-toggle');
  const navigation = document.querySelector('.main-nav');
  menuToggle?.addEventListener('click', () => {
    const open = navigation?.classList.toggle('open') || false;
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  });
  navigation?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    navigation.classList.remove('open');
    menuToggle?.setAttribute('aria-expanded', 'false');
  }));

  navigation?.querySelectorAll('.main-nav-dropdown-toggle').forEach(button => button.addEventListener('click', () => {
    const item = button.closest('.main-nav-item');
    const open = item?.classList.toggle('is-open') || false;
    button.setAttribute('aria-expanded', String(open));
  }));

  const accountToggle = document.querySelector('[data-account-toggle]');
  const loginDialog = document.querySelector('#CustomerLoginDialog');
  const accountClose = document.querySelector('[data-account-close]');
  accountToggle?.addEventListener('click', () => {
    if (loginDialog?.showModal) loginDialog.showModal();
    else window.location.href = accountToggle.dataset.accountUrl || '/account/login';
    accountToggle.setAttribute('aria-expanded', 'true');
    loginDialog?.querySelector('input[type="email"]')?.focus();
  });
  accountClose?.addEventListener('click', () => loginDialog?.close());
  loginDialog?.addEventListener('close', () => accountToggle?.setAttribute('aria-expanded', 'false'));
  loginDialog?.addEventListener('click', event => {
    if (event.target === loginDialog) loginDialog.close();
  });

  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', () => {
      const opening = searchPanel.hidden;
      searchPanel.hidden = !opening;
      document.querySelector('.site-header')?.classList.toggle('search-open', opening);
      searchToggle.setAttribute('aria-expanded', String(opening));
      if (opening) searchPanel.querySelector('input')?.focus();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !searchPanel.hidden) {
        searchPanel.hidden = true;
        document.querySelector('.site-header')?.classList.remove('search-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  document.querySelectorAll('[data-carousel-target]').forEach(button => {
    button.addEventListener('click', () => {
      const track = document.querySelector(button.dataset.carouselTarget);
      if (track) track.scrollBy({ left: button.dataset.direction === '-1' ? -track.clientWidth * 0.8 : track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  const initNewArrivals = (scope = document) => {
    scope.querySelectorAll('[data-auto-product-slider]').forEach(track => {
      if (track.dataset.sliderReady === 'true') return;
      track.dataset.sliderReady = 'true';
      const cards = [...track.querySelectorAll('.new-arrivals-card')];
      if (cards.length < 2) return;
      const stepSize = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
      const move = direction => track.scrollBy({ left: direction * stepSize(), behavior: 'smooth' });
      track.closest('.new-arrivals')?.querySelectorAll('[data-new-arrivals-step]').forEach(button => {
        button.addEventListener('click', () => move(Number(button.dataset.newArrivalsStep)));
      });
      const interval = Math.max(3, Number(track.dataset.slideInterval) || 4) * 1000;
      const timer = window.setInterval(() => {
        if (track.matches(':hover, :focus-within') || document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const end = track.scrollWidth - track.clientWidth;
        if (track.scrollLeft >= end - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
        else move(1);
      }, interval);
      track.dataset.sliderTimer = String(timer);
    });
  };
  initNewArrivals();
  document.addEventListener('shopify:section:load', event => initNewArrivals(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-auto-product-slider]').forEach(track => {
      window.clearInterval(Number(track.dataset.sliderTimer));
      delete track.dataset.sliderReady;
    });
  });

  document.querySelectorAll('[data-collection-sort]').forEach(select => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  document.querySelectorAll('[data-filter-toggle]').forEach(button => {
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
      button.querySelector('span').textContent = open ? '−' : '＋';
    });
  });


  document.querySelectorAll('[data-occasion-button]').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-occasion-button]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const title = document.querySelector('[data-occasion-title]');
      const text = document.querySelector('[data-occasion-text]');
      const link = document.querySelector('[data-occasion-link]');
      if (title) title.textContent = button.dataset.title || '';
      if (text) text.textContent = button.dataset.copy || '';
      if (link && button.dataset.whatsapp) link.href = button.dataset.whatsapp;
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const price = document.querySelector('[data-product-price]');
      if (price && option?.dataset.price) {
        const cents = Number(option.dataset.price);
        const currency = document.documentElement.dataset.currency || 'INR';
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency }).format(cents / 100);
      }
      const addButton = select.closest('form')?.querySelector('[name="add"]');
      if (addButton && option) addButton.disabled = option.dataset.available !== 'true';
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(track => {
    const slides = [...track.querySelectorAll('[data-gallery-open]')];
    if (!slides.length) return;
    const gallery = track.closest('.product-gallery');
    const currentLabel = gallery?.querySelector('[data-gallery-current]');
    const thumbnails = [...(gallery?.querySelectorAll('[data-gallery-thumb]') || [])];
    const zoomDialog = document.querySelector('[data-zoom-dialog]');
    const zoomImage = zoomDialog?.querySelector('[data-zoom-image]');
    let currentIndex = 0;
    let scrollFrame = null;

    const showIndex = (index, smooth = true) => {
      currentIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: currentIndex * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      syncGallery();
    };
    const syncGallery = () => {
      currentIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      if (currentLabel) currentLabel.textContent = String(currentIndex + 1).padStart(2, '0');
      thumbnails.forEach((thumb, index) => {
        const active = index === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    const openZoom = index => {
      currentIndex = index;
      if (!zoomDialog || !zoomImage) return;
      zoomImage.src = slides[currentIndex].dataset.zoomSrc;
      zoomImage.alt = slides[currentIndex].querySelector('img')?.alt || '';
      zoomImage.classList.remove('is-zoomed');
      if (!zoomDialog.open) zoomDialog.showModal();
    };
    const changeZoomImage = delta => {
      currentIndex = (currentIndex + delta + slides.length) % slides.length;
      if (zoomImage) {
        zoomImage.src = slides[currentIndex].dataset.zoomSrc;
        zoomImage.alt = slides[currentIndex].querySelector('img')?.alt || '';
        zoomImage.classList.remove('is-zoomed');
      }
      showIndex(currentIndex);
    };

    track.addEventListener('scroll', () => {
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(syncGallery);
    }, { passive: true });
    gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showIndex(currentIndex - 1));
    gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => showIndex(currentIndex + 1));
    gallery?.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => openZoom(currentIndex));
    thumbnails.forEach(thumb => thumb.addEventListener('click', () => showIndex(Number(thumb.dataset.imageIndex))));
    slides.forEach(slide => slide.addEventListener('click', () => openZoom(Number(slide.dataset.imageIndex))));
    zoomDialog?.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoomDialog.close());
    zoomDialog?.querySelector('[data-zoom-prev]')?.addEventListener('click', () => changeZoomImage(-1));
    zoomDialog?.querySelector('[data-zoom-next]')?.addEventListener('click', () => changeZoomImage(1));
    zoomImage?.addEventListener('click', () => zoomImage.classList.toggle('is-zoomed'));
    zoomDialog?.addEventListener('click', event => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
    zoomDialog?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); changeZoomImage(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); changeZoomImage(1); }
    });
  });

  document.querySelectorAll('[data-copy-product-link]').forEach(button => {
    button.addEventListener('click', async () => {
      const status = button.closest('.product-share-row')?.querySelector('[data-share-status]');
      try {
        await navigator.clipboard.writeText(button.dataset.shareUrl);
        if (status) status.textContent = 'Link copied';
      } catch {
        if (status) status.textContent = 'Copy this page link from your browser';
      }
      window.setTimeout(() => { if (status) status.textContent = ''; }, 2600);
    });
  });

  document.querySelectorAll('[data-native-share]').forEach(button => {
    button.addEventListener('click', async () => {
      const status = button.closest('.product-share-row')?.querySelector('[data-share-status]');
      if (!navigator.share) {
        if (status) status.textContent = 'Use the other icons to share this saree';
        window.setTimeout(() => { if (status) status.textContent = ''; }, 2600);
        return;
      }
      try {
        await navigator.share({ title: button.dataset.shareTitle, url: button.dataset.shareUrl });
      } catch (error) {
        if (error.name !== 'AbortError' && status) status.textContent = 'Sharing is unavailable right now';
      }
    });
  });

  const setupRelatedCarousel = section => {
    const grid = section.querySelector('[data-recommendation-grid]');
    const controls = section.querySelector('[data-related-controls]');
    if (!grid || !controls) return;
    const updateControls = () => { controls.hidden = grid.scrollWidth <= grid.clientWidth + 2; };
    if (!controls.dataset.bound) {
      controls.dataset.bound = 'true';
      controls.querySelector('[data-related-prev]')?.addEventListener('click', () => grid.scrollBy({ left: -grid.clientWidth * .82, behavior: 'smooth' }));
      controls.querySelector('[data-related-next]')?.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth * .82, behavior: 'smooth' }));
      grid.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
    }
    requestAnimationFrame(updateControls);
  };

  document.querySelectorAll('product-recommendations[data-url]').forEach(async section => {
    setupRelatedCarousel(section);
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const resultSection = parsed.querySelector('product-recommendations');
      const resultGrid = resultSection?.querySelector('[data-recommendation-grid]');
      const currentGrid = section.querySelector('[data-recommendation-grid]');
      if (resultGrid?.children.length && currentGrid) {
        currentGrid.innerHTML = resultGrid.innerHTML;
        const emptyMessage = section.querySelector('[data-recommendation-empty]');
        if (emptyMessage) emptyMessage.hidden = true;
        setupRelatedCarousel(section);
      }
    } catch (error) {
      console.warn('Related saree recommendations could not be loaded.', error);
    }
  });
});
